export const congregationRoleConsts = {
  LOAD_REQUEST: '[Congregation Roles] LOAD_REQUEST',
  LOAD_FAILURE: '[Congregation Roles] LOAD_FAILURE',
  LOAD_SUCCESS: '[Congregation Roles] LOAD_SUCCESS'
};
